<app-auth-form
	[isRegister]="2"
	(formSubmit)="onReset($event)"
></app-auth-form>
